import SocialLinks from '@package/components/SocialLinks';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Button from '@package/components/Button';
import Icon from '@package/components/Icon';
import Logo from '@package/components/Logo';
import { accessibleOnClick } from '@package/helpers/accessibleOnClick';
import Footer from './components/Footer';
import Group from './components/Group';

const MobileNavigationBody = ({
  // title,
  'close-label': closeLabel,
  active,
  onToggleMenu,
  children,
}) => {
  const Groups = React.Children.map(children, (child) =>
    child.type.displayName === 'Group' ? child : null,
  );

  const [activeGroup, setActiveGroup] = useState(
    React.Children.count(Groups) > 0 && Groups[0].key,
  );

  if (React.Children.count(Groups) === 0) {
    return null;
  }

  const Content = React.Children.map(Groups, (group) => {
    const collapsible = React.Children.count(Groups) > 1;
    const isActive = group.key === activeGroup;

    const onGroupSelect = () => {
      if (activeGroup === group.key) {
        setActiveGroup('');
      } else {
        setActiveGroup(group.key);
      }
    };

    return React.cloneElement(group, {
      active: isActive,
      collapsible,
      onGroupSelect: collapsible ? onGroupSelect : null,
      onNavigate: onToggleMenu,
    });
  });

  const Footer = React.Children.map(children, (child) =>
    child.type.displayName === 'Footer' ? child : null,
  );

  return (
    <>
      {!!active && (
        <div
          className="scrim"
          aria-expanded="true"
          aria-label={closeLabel}
          {...accessibleOnClick(onToggleMenu)}
        />
      )}
      <div className={cx('mobile-nav', { active })}>
        <div className="header">
          <Button
            circle
            link
            className="close"
            onClick={onToggleMenu}
            title={closeLabel}
          >
            <Icon name="close" />
          </Button>

          <Logo />
        </div>

        <div className="top">
          <div className="search">
            <SearchWidget onSubmit={() => onToggleMenu()} />
          </div>
        </div>
        <div className="content">{!!active && Content}</div>
        <SocialLinks className="social" />
        {Footer}
      </div>
    </>
  );
};

MobileNavigationBody.Group = Group;
MobileNavigationBody.Footer = Footer;

MobileNavigationBody.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  onToggleMenu: PropTypes.func,
  'menu-label': PropTypes.string,
  'close-label': PropTypes.string,
  children: PropTypes.node,
};

MobileNavigationBody.defaultProps = {
  'menu-label': 'Main navigation menu',
  'close-label': 'Close menu',
  active: false,
};

export default MobileNavigationBody;
